import {
  Activity,
  BarChart3,
  Building2,
  Calendar,
  CheckSquare,
  Filter,
  Home,
  Linkedin,
  MessageSquare,
  Crosshair,
  TrendingUp,
  Users,
  Zap,
  Search,
  Youtube,
  FileText,
  ShieldCheck,
} from 'lucide-react';

export const socialChannelModules = [
  { to: '/dashboard/instagram', icon: MessageSquare, label: 'Instagram', category: 'channels' },
  { to: '/dashboard/crm/marketing/ad-configuration', icon: Crosshair, label: 'Ad Configuration', category: 'channels', comingSoon: true },
  { to: '/dashboard/crm/marketing/meta-manager', icon: Crosshair, label: 'Meta Ads', category: 'channels', comingSoon: true },
  { to: '/dashboard/crm/marketing/google-manager', icon: Search, label: 'Google Ads', category: 'channels', comingSoon: true },
  { to: '/dashboard/crm/marketing/tiktok-manager', icon: Crosshair, label: 'TikTok Ads', category: 'channels', comingSoon: true },
  { to: '/dashboard/crm/marketing/linkedin-manager', icon: Linkedin, label: 'LinkedIn Ads', category: 'channels', comingSoon: true },
  { to: '/dashboard/crm/marketing/youtube-manager', icon: Youtube, label: 'YouTube Ads', category: 'channels', comingSoon: true },
  { to: '/dashboard/autoreply', icon: Zap, label: 'Auto Reply Flows', category: 'channels', comingSoon: true },
  { to: '/dashboard/whatsapp/templates', icon: FileText, label: 'Message Templates', category: 'whatsapp', comingSoon: true },
  { to: '/dashboard/whatsapp/consent', icon: ShieldCheck, label: 'Consent Manager', category: 'whatsapp', comingSoon: true },
];

export const crmCoreModules = [
  { to: '/dashboard/crm', icon: Home, label: 'Revenue Hub', category: 'overview' },
  { to: '/dashboard/crm/leads', icon: Users, label: 'Leads', category: 'crm', description: 'Unified Sales & Marketing Leads' },
  { to: '/dashboard/crm/deals', icon: TrendingUp, label: 'Deals', category: 'crm' },
  { to: '/dashboard/crm/tasks', icon: CheckSquare, label: 'Tasks', category: 'crm' },
  { to: '/dashboard/crm/ai-planner', icon: Zap, label: 'AI Planner', category: 'crm' },
  { to: '/dashboard/crm/contacts', icon: MessageSquare, label: 'Contacts', category: 'crm' },
  { to: '/dashboard/crm/accounts', icon: Building2, label: 'Accounts', category: 'crm' },
  { to: '/dashboard/crm/activities', icon: Activity, label: 'Activities', category: 'crm' },
  { to: '/dashboard/crm/events', icon: Calendar, label: 'Events', category: 'crm' },
];

export const adsAutomationModules = [
  { to: '/dashboard/crm/marketing', icon: BarChart3, label: 'Marketing Dashboard', category: 'marketing' },
  { to: '/dashboard/crm/marketing/segments', icon: Filter, label: 'Segments', category: 'automation', comingSoon: true },
  { to: '/dashboard/crm/marketing/journeys', icon: Zap, label: 'Journeys', category: 'automation', comingSoon: true },
  { to: '/dashboard/crm/marketing/campaigns', icon: Crosshair, label: 'Campaigns', category: 'marketing' },
  { to: '/dashboard/crm/marketing/reports', icon: BarChart3, label: 'Campaign Reports', category: 'marketing', comingSoon: true },
  { to: '/dashboard/crm/marketing/acquisition', icon: TrendingUp, label: 'Acquisition', category: 'marketing', comingSoon: true },
  { to: '/dashboard/crm/marketing/platform-comparison', icon: TrendingUp, label: 'Platform Comparison', category: 'marketing', comingSoon: true },
];

export const revopsModules = [...socialChannelModules, ...crmCoreModules, ...adsAutomationModules];
